import './item-edit-menu.scss'

import { faCheck, faTabletAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import Component from 'vue-class-component';

import { OfflineDataFetcher } from '@skinsoft/data-store';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { DELETE_MODIFICATIONS_NOT_SYNCHRONIZED, DELETE_NOT_SYNCHRONIZED_NEW_ITEM, SAVE_CURRENT_ITEM_TOPIC, TOGGLE_MENU_TOPIC } from '@skinsoft/bus';

@Component({
    components: {

    },
    props: [''],
    template: require('./item-edit-menu.html')
})
export class ItemEditMenu extends ReactiveVue {

    private get displayLocalWarning() {
        return !this.onLine || (this.itemId && OfflineDataFetcher.isTemporaryId(this.itemId));
    }

    private get isNewItemNotSynchronized() {
        return this.itemId && OfflineDataFetcher.isTemporaryId(this.itemId);
    }


    private itemId: string = ""
    private onLine: boolean = false;
    private running = false;

    private transitionCallback: () => void

    // Icons 
    private checkIcon = faCheck;
    private crossIcon = faTimes;
    private warningIcon = faTabletAlt;

    public mounted() {
        this.itemId = _.get(this.$route, 'params.itemId');
    }

    public created() {
        this.running = true;
        this.onFrame();
    }

    public beforeDestroy() {
        this.running = false;
    }

    public saveItem() {
        this.emitOnBus(SAVE_CURRENT_ITEM_TOPIC);
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    public deleteNotSynchronizedNewItem() {
        this.emitOnBus(DELETE_NOT_SYNCHRONIZED_NEW_ITEM);
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    public deleteModificationsNotSynchronized() {
        this.emitOnBus(DELETE_MODIFICATIONS_NOT_SYNCHRONIZED);
        this.emitOnBus(TOGGLE_MENU_TOPIC);
    }

    private onFrame() {
        this.onLine = window.navigator.onLine;
        if (this.running) {
            requestAnimationFrame(this.onFrame);
        }
    }

}